"use strict";
//@ts-check
Object.defineProperty(exports, "__esModule", { value: true });
exports.modules = void 0;
// Import core-globals first!
require("./_globals");
var basic = require("./basic");
var indexes = require("./indexes");
var jsInterface = require("./js-interface");
var elementwise = require("./elementwise");
var print = require("./print");
var reduce = require("./reduce");
var operators = require("./operators");
var transform = require("./transform");
exports.modules = {
    basic: basic,
    jsInterface: jsInterface,
    indexes: indexes,
    elementwise: elementwise,
    print: print,
    reduce: reduce,
    operators: operators,
    transform: transform,
};
